import React from 'react';
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  BarChart,
  Bar,
} from 'recharts';

export interface BarChartProps {
  data: any[];
  optimalMax?: number;
  optimalMin?: number;
}

export const RootineBarChart = (props: BarChartProps): JSX.Element => {
  const epochToString = (epoch: string): string => {
    const date = new Date(epoch);
    return `${date.toLocaleString('default', {
      month: 'short',
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={props.data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickFormatter={(epoch) => epochToString(epoch)}
          />
          <YAxis type="number" />
          <Tooltip labelFormatter={(epoch) => epochToString(epoch)} />
          <Bar dataKey="result" fill="#0075FF" opacity={0.8} />
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};
